import type { LLMChoice } from './room'

export interface ConfigurationFormValues {
  greetings: string
  prompt: string
  scenario: string
  restrictions: string // Ensure this matches the field name in the backend
  file: number[] // Array of file IDs
}

export interface DocumentRAGSettings {
  use_full_context?: boolean
  rag_enabled?: boolean | null
  rag_top_k?: number | null
  rag_chunk_size?: number | null
  rag_chunk_overlap?: number | null
  rag_similarity_threshold?: number | null
  rag_max_context_length?: number | null
}

export interface MyFile {
  id: number
  file: string // URL of the file
  file_name: string
  file_size: number // In KB
  file_url: string // Local/hosted file URL
  directory: string
  uploaded_at: string // ISO date string
  user: null | number // If user data is available
  rag_settings?: DocumentRAGSettings
}

export interface ConfigurationState {
  files: MyFile[]
  formData: ConfigurationFormValues | null
  loading: boolean
  error: string | null
}

export interface AdvisorDataWithFiles {
  file_ids: number[]
  restrictions: string
  greetings: string
  prompt: string
  scenario: string
  temperature: number
  max_tokens: number
  history_limit: number
  rag_enabled: boolean
  rag_top_k: number
  rag_chunk_size: number
  rag_chunk_overlap: number
  rag_similarity_threshold: number
  rag_max_context_length: number
  currency_cost?: number | null
  document_settings?: Record<number, DocumentRAGSettings>
  document_settings_data?: Record<string, DocumentRAGSettings>
  chatbot_llm?: LLMChoice
  use_room_default_documents?: boolean
  use_room_default_behavioral_config?: boolean
}

export enum ChatbotType {
  ADVISOR = 1,
  RANDR = 2,
  ADJUDICATION = 3,
  GAME_ANALYSIS_ASSISTANT = 4,
  DECISION_MAKER = 5,
  PREP_COACH = 6,
  GROUP_MODERATOR = 7,
}

export interface ReprocessDocumentResult {
  document_id: number
  document_name: string
  status: 'success' | 'skipped' | 'failed'
  chunks_created?: number
  reason?: string
  error?: string
}

export interface ReprocessDocumentsResponse {
  success: boolean
  processed: number
  skipped: number
  failed: number
  results: ReprocessDocumentResult[]
}
